/**
 * Labstep
 *
 * @module components/Comment/SideMenu
 * @desc Side menu for comment threads in notifications
 */

import { CommentItemContainer } from 'labstep-web/components/Comment/Item';
import { LayoutMenuSideContainer as SideMenu } from 'labstep-web/components/Layout/Menu/Side';
import { ThreadModal } from 'labstep-web/components/Thread/Modal';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Comment } from 'labstep-web/models/comment.model';
import styles from './styles.module.scss';
import type { ICommentSideMenuProps } from './types';

export const CommentSideMenu: RFC<ICommentSideMenuProps> = ({
  notification,
  markAsRead,
  children,
}) => {
  if (!notification.metadata?.parent_thread_id) {
    return null;
  }
  return (
    <SideMenu
      header="Thread"
      name="sub-comment-thread"
      viewComponent={({ toggleSideMenu }) => (
        <div
          className={styles.viewContainer}
          onClick={() => {
            toggleSideMenu();
            markAsRead();
          }}
        >
          {children}
        </div>
      )}
    >
      <ThreadModal
        showCreateComment={false}
        threadId={notification.metadata.parent_thread_id}
        top={
          <ReadOnMountHOC
            type="entities"
            entityName={Comment.entityName}
            loading={{ loader: 'placeholder', multiplier: 1 }}
            params={{
              get_single: 1,
              is_deleted: 'both',
              id: notification.metadata.parent_thread_comment_id,
            }}
            children={({ entity }) => (
              <CommentItemContainer readOnly comment={entity} />
            )}
          />
        }
      />
    </SideMenu>
  );
};
